import { Grid } from "@mui/material";
import { useEffect } from "react";
import DailySummary from "./DailySummary";
import DashboardSearch from "./DashboardSearch";
import { preloadMenuStats } from "../layout/PreloadMenuStats";
import DailyQuickLinkBox from "./DailyQuickLinkBox";

const styles = {
  singleCol: { marginTop: "1em", marginBottom: "1em" },
};

const Dashboard = () => {
  // useEffect(() => {
  //   preloadMenuStats("loan");
  //   preloadMenuStats("customer");
  //   preloadMenuStats("application");
  // }, []);
  return (
    <>
      {/* <Welcome /> */}
      <Grid
        container
        spacing={1}
        sx={{
          width: "100%",
          display: "grid",
          gridTemplateColumns: "310px 1fr",
          gap: "16px",
        }}
      >
        <Grid sx={{ width: "300px", flexShrink: 0 }}>
          <div style={styles.singleCol}>
            <DailySummary />
          </div>
        </Grid>

        <Grid sx={{ flex: "1 1 auto", minWidth: 0 }}>
          <div style={styles.singleCol}>
            <DailyQuickLinkBox />
            <DashboardSearch />
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default Dashboard;
